import React, { useState } from "react";

import { useMutation, useQuery } from "@apollo/client";
import get from "lodash/get";
import { useParams } from "react-router";
import { CREATE_INTERVENTION_ADDRESS } from "shared/graphql/mutations";
import {
  CIVILITIES,
  COUNTRIES,
  INTERVENTION_ADDRESS_INFO,
} from "shared/graphql/queries";

import View from "./View";

const Component = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({});
  const [updatable, setUpdatable] = useState({});
  const [addressError, setAddressError] = useState();
  const [geolocalized, setGeolocalized] = useState();

  const civilitiesQuery = useQuery(CIVILITIES);
  const countriesQuery = useQuery(COUNTRIES);

  useQuery(INTERVENTION_ADDRESS_INFO, {
    variables: { where: { folderNum: id } },
    onCompleted: (result) => {
      const data = get(result, "getInterventionAddress.data", {});
      setValues({
        civilityCode: data.civilityCode,
        firstname: data.firstname,
        name: data.name,
        address1: data.address1,
        address2: data.address2,
        town: data.town,
        postCode: data.postCode,
        countryCode: data.countryCode,
        email: data.email,
        cellPhone: "",
        updateAccount: false,
        forceData: false,
        phone: data.phone,
      });
      setUpdatable(data.updatable);
    },
  });

  const [createAddress] = useMutation(CREATE_INTERVENTION_ADDRESS, {
    onCompleted: (res) => {
      setGeolocalized(res?.createInterventionAddress?.geolocalized);
    },
    onError: (error) => {
      const _error = get(error.graphQLErrors, "[0].extensions");
      setAddressError(_error);
      setLoading(false);
    },
  });

  const onSubmit = async () => {
    setLoading(true);
    const data = Object.entries(values).reduce(
      (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
      {},
    );

    await createAddress({
      variables: { where: { folderNum: id }, data: { ...data } },
    });
    setValues({ ...values, updateAccount: false });
    setLoading(false);
  };

  const onForceData = async () => {
    setLoading(true);
    const data = Object.entries({
      ...values,
      forceData: true,
    }).reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});
    await createAddress({
      variables: { where: { folderNum: id }, data: { ...data } },
    });
    setValues({ ...values, updateAccount: false });
    setLoading(false);
  };

  return (
    <View
      loading={loading}
      values={values}
      geolocalized={geolocalized}
      onChange={setValues}
      civilitiesQuery={{
        loading: civilitiesQuery.loading,
        data: get(civilitiesQuery, "data.civilities.data", []),
      }}
      countriesQuery={{
        loading: countriesQuery.loading,
        data: get(countriesQuery, "data.countries.data", []),
      }}
      error={addressError}
      updatable={updatable}
      onSubmit={onSubmit}
      onForceData={onForceData}
    />
  );
};

export default Component;
